import { getCallable } from "../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    GetWorkspaceResourcesRequest, GetWorkspaceResourcesResponse,
    UpdateWorkspaceResourceRequest, UpdateWorkspaceResourceResponse,
    DeleteWorkspaceResourceRequest, DeleteWorkspaceResourceResponse,
    CreateWorkspaceResourceRequest, CreateWorkspaceResourceResponse
} from "./types";

export { apiName };

const getWorkspaceResources = getCallable<GetWorkspaceResourcesRequest, GetWorkspaceResourcesResponse>(
    apiName,
    "getWorkspaceResources",
    {
        ...endpoints.getWorkspaceResources,
        composer: request => {
            const searchParams = new URLSearchParams();
            if (request.resources) {
                searchParams.append("resources", JSON.stringify(request.resources));
            }

            return {
                url: `/workspaces/${request.workspaceId}/resources?${searchParams.toString()}`,
                options: {
                    method: "GET"
                }
            };
        }
    }
);

const updateWorkspaceResource = getCallable<UpdateWorkspaceResourceRequest, UpdateWorkspaceResourceResponse>(
    apiName,
    "updateWorkspaceResource",
    {
        ...endpoints.updateWorkspaceResource,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/resources/${request.resourceType}/${request.resourceId}`,
                options: {
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            };
        }
    }
);

const deleteWorkspaceResource = getCallable<DeleteWorkspaceResourceRequest, DeleteWorkspaceResourceResponse>(
    apiName,
    "deleteWorkspaceResource",
    {
        ...endpoints.deleteWorkspaceResource,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/resources/${request.resourceType}/${request.resourceId}`,
                options: { method: "DELETE" }
            };
        }
    }
);

const createWorkspaceResource = getCallable<CreateWorkspaceResourceRequest, CreateWorkspaceResourceResponse>(
    apiName,
    "createWorkspaceResource",
    {
        ...endpoints.createWorkspaceResource,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/resources`,
                options: { method: "POST", body: JSON.stringify(request) }
            };
        }
    }
);

export const callables = {
    getWorkspaceResources,
    updateWorkspaceResource,
    deleteWorkspaceResource,
    createWorkspaceResource
};

